import { useState } from "react";
import { Flame, X } from "lucide-react";

export default function TransitionBanner({ onDismiss }) {
    const [visible, setVisible] = useState(true);
    if (!visible) return null;
    return (
        <div
            data-testid="transition-notice"
            role="status"
            className="fixed inset-x-0 top-0 z-[60] border-b border-amber-500/25"
            style={{
                background:
                    "linear-gradient(90deg, rgb(36,24,9) 0%, rgb(58,40,18) 50%, rgb(36,24,9) 100%)",
            }}
        >
            <div className="mx-auto flex w-full max-w-6xl items-center justify-center gap-3 px-4 py-2.5 sm:px-6">
                <Flame className="h-4 w-4 shrink-0 text-amber-400" />
                <p
                    data-testid="transition-text"
                    className="text-center text-xs leading-snug text-amber-100/90 sm:text-sm"
                >
                    <span className="font-serif italic text-amber-300">
                        Same Safe Space
                    </span>
                    , new name — we're now{" "}
                    <span className="font-serif italic text-amber-300">
                        NeuroPlay Counseling, LLC
                    </span>
                    . Same warm room, same care, same team.
                </p>
                <button
                    data-testid="transition-dismiss-button"
                    aria-label="Dismiss announcement"
                    onClick={() => {
                        setVisible(false);
                        onDismiss && onDismiss();
                    }}
                    className="ml-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-amber-200/60 transition-colors duration-200 hover:bg-amber-500/15 hover:text-amber-100"
                >
                    <X className="h-3.5 w-3.5" />
                </button>
            </div>
        </div>
    );
}
